import React, { Component } from "react";
import axios from "axios";
import Pagination from "./Pagination";
import { LangContext } from "../LangContext.jsx";
class MyDossierFiles extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            files: [],
            providerFiles: [],
            selectedFiles: [],
            selectedProviderFiles: [],
            currentPage: 1,
            filesPerPage: 10,
            activeTab: "files",
            totalFiles: 0,
          };
        this.handleChange = this.handleChange.bind(this);
        this.handleProviderChange = this.handleProviderChange.bind(this);
    }

    componentDidMount() {
        this.getFiles();
    }

    async getFiles() {
        const response = await axios.get('/api/files');
        this.setState({
          files: response.data.files,
          providerFiles: response.data.providerFiles,
        });
      }      
      

    handleChange(e) {
        const index = e.target.value;
        const d = {
            id: this.state.files[index].id
        };
        if (e.target.checked) {
            this.setState(prevState => ({
                selectedFiles: [...prevState.selectedFiles, d]
            }));
        } else {
            this.removeFile(d.id);
        }
    }

    componentWillReceiveProps(props) {
        if (props.selected_files != null) {
            this.setState({ selectedFiles: props.selected_files })
        }
        if (props.selected_provider_files != null) {
            this.setState({ selectedProviderFiles: props.selected_provider_files })
        }
    }

    handleProviderChange(e) {
        const index = e.target.value;
        const d = {
            id: this.state.providerFiles[index].id
        };
        if (e.target.checked) {
            this.setState(prevState => ({
                selectedProviderFiles: [...prevState.selectedProviderFiles, d]
            }));
        } else {
            this.removeProviderFile(d.id);
        }
    }

    removeFile(id) {
        const updatedSelectedFiles = this.state.selectedFiles.filter(file => file.id !== id);
        this.setState({ selectedFiles: updatedSelectedFiles });
    }

    removeProviderFile(id) {
        const updatedSelectedProviderFiles = this.state.selectedProviderFiles.filter(file => file.id !== id);
        this.setState({ selectedProviderFiles: updatedSelectedProviderFiles });
    }

    handleTabClick = (tab, e) => {
        e.preventDefault();
        this.setState({ activeTab: tab }, () => {
            this.getFiles();
        });
        this.setState({ currentPage: 1 });
    }

    updateCurrentPage = (tab, newPage) => {
        this.setState({ currentPage: newPage });
    }

    render() {
        const { lang } = this.context; 
        const { currentPage, filesPerPage, files, providerFiles, activeTab } = this.state;
        //const totalFiles = activeTab === "files" ? files.length : providerFiles.length;
        const currentFiles = activeTab === "files" ? files : providerFiles;
        const mergedSelectedFiles = [...this.state.selectedFiles, ...this.state.selectedProviderFiles];

        const indexOfLastFile = currentPage * filesPerPage;
        const indexOfFirstFile = indexOfLastFile - filesPerPage;
        const currentFilesPage = currentFiles.slice(indexOfFirstFile, indexOfLastFile);

        const totalMyFiles = this.state.files.length;
        const totalProviderFiles = this.state.providerFiles.length;
        const totalFiles = activeTab === "files" ? totalMyFiles : totalProviderFiles;

        return (
            <div className="card card-custom gutter-b my-5">
                <div className="card-body">
                    <ul className="nav nav-tabs nav-tabs-line">
                        <li className="nav-item">
                            <a
                                className={`nav-link ${activeTab === "files" ? "active" : ""}`}
                                onClick={(e) => this.handleTabClick("files", e)}
                                style={{cursor: 'pointer'}}
                                data-toggle="tab"
                            >
                                {lang.get('messages.archivos_solicitados')} &nbsp;<span className="badge badge-secondary">{files.length}</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${activeTab === "providerFiles" ? "active" : ""}`}
                                onClick={(e) => this.handleTabClick("providerFiles", e)}
                                style={{cursor: 'pointer'}}
                                data-toggle="tab"
                            >
                                {lang.get('messages.mis_archivos')} &nbsp;<span className="badge badge-secondary">{providerFiles.length}</span>
                            </a>
                        </li>
                    </ul>

                    <div className="card card-custom gutter-b">
                        <div className="card-body">
                            <div className="row justify-content-center text-left">
                                <div className="col-sm-12 mb-2">
                                    <p className="font-weight-bold">{lang.get('messages.selecciona_los_documentos_del_listado_disponible')}</p>
                                    <div className="col-12 pt-6 pb-2 pr-6 pl-6 card bg-light-light min-h-200px"> 
                                        {currentFilesPage.map((file, i) => {
                                            const exist = mergedSelectedFiles.some(item => file.id == item.id);
                                            if(activeTab === "files"){
                                                return (
                                                    <div key={i} className="d-flex">
                                                        <div className="checkbox-inline mr-5">
                                                            <span className="d-flex align-items-center mr-3" data-inbox="actions">
                                                                <label className="checkbox checkbox-outline mb-7">
                                                                    <input
                                                                        id="radio"
                                                                        type="checkbox"
                                                                        value={i}
                                                                        checked={exist}
                                                                        onChange={activeTab === "files" ? this.handleChange : this.handleProviderChange}
                                                                        label="Add"
                                                                    />
                                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                                </label>

                                                                <img
                                                                    className="ml-6 mr-4 mb-7"
                                                                    src={"/assets/img/" + window.getMimeSVG(file.file.extension != undefined && file.file.extension.length > 0 ? file.file.extension : file.file.path)}
                                                                />
                                                                {file.file.title} 
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <div key={i} className="d-flex">
                                                        <div className="checkbox-inline mr-5">
                                                            <span className="d-flex align-items-center mr-3" data-inbox="actions">
                                                                <label className="checkbox checkbox-outline mb-7">
                                                                    <input
                                                                        id="radio-new"
                                                                        type="checkbox"
                                                                        value={i}
                                                                        checked={exist}
                                                                        onChange={activeTab === "files" ? this.handleChange : this.handleProviderChange}
                                                                    />
                                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                                </label>
                                                                <img
                                                                    className="ml-6 mr-4"
                                                                    src={"/assets/img/" + window.getMimeSVG(file.extension != undefined && file.extension.length > 0 ? file.extension : file.path)}
                                                                    //src={"/assets/img/" + file.mime + '.svg'}
                                                                />
                                                                {file.title}
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Pagination Controls */}
                    {totalFiles > filesPerPage && (
                        <Pagination
                            currentPage={currentPage}
                            totalFiles={activeTab === "files" ? totalMyFiles : totalProviderFiles}
                            filesPerPage={filesPerPage}
                            updateCurrentPage={this.updateCurrentPage}
                            activeTab={activeTab}
                            split={10}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default MyDossierFiles;